const textStyleVariants = {
    display1: 'text-display1',
    display2: 'text-display2',
    display3: 'text-display3',
    heading1: 'text-heading1',
    heading2: 'text-heading2',
    heading3: 'text-heading3',
    heading4: 'text-heading4',
    heading5: 'text-heading5',
    heading6: 'text-heading6',
    subheading1: 'text-subheading1',
    subheading2: 'text-subheading2',
    subheading3: 'text-subheading3',
    subheading4: 'text-subheading4',
    body1: 'text-body1',
    body2: 'text-body2',
    body3: 'text-body3',
    action1: 'text-action1',
    action2: 'text-action2',
    action3: 'text-action3',
    article: 'text-article',
    disclaimer: 'text-disclaimer',
    label: 'text-label'
};
const textStyles = Object.keys(textStyleVariants);
export { textStyleVariants, textStyles };
